import styled, { css } from 'styled-components';

import { Cross } from '@solent-university/solent-icons';

import Arrow from 'Elements/Link/Arrow';

export const Top = styled.div`
    padding-bottom: 0;
`;

export const Heading = styled.h2`
    ${({ theme }) => css`
        font-size: 1.625rem;
        margin: 0;

        @media ${theme.breakpoints.large.media} {
            font-size: 2.25rem;
        }
    `}
`;

export const Listing = styled.ul`
    ${({ theme }) => css`
        list-style-type: none;
        padding: 0;
        margin-bottom: 1.5rem;
        display: grid;
        grid-template-columns: repeat(12, 1fr);
        gap: 1.5rem;

        @media ${theme.breakpoints.medium.media} {
            gap: 0.75rem;
        }

        @media ${theme.breakpoints.large.media} {
            margin-top: 0.75rem;
            margin-bottom: 2rem;
            column-gap: 1.5rem;
            row-gap: 2rem;
        }
    `}
`;

export const ListItem = styled.li`
    ${({ theme }) => css`
        grid-column-start: span 12;

        @media ${theme.breakpoints.medium.media} {
            grid-column: 2 / 12;
        }

        @media ${theme.breakpoints.large.media} {
            grid-column: span 4;
        }
    `}
`;

export const ButtonWrapper = styled.div`
    ${({ theme }) => css`
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 1.5rem;

        @media ${theme.breakpoints.large.media} {
            margin-bottom: 2rem;
        }

        @media ${theme.breakpoints.large.media} {
            margin-bottom: 2.5rem;
        }
    `}
`;

export const CoursesViewedText = styled.p`
    ${({ theme }) => css`
        margin: 0 0 0.75rem 0;
        color: ${theme.colors.accents[5].hex};
    `}
`;

export const ViewAllLinksContainer = styled.div`
    ${({ theme }) => css`
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        text-align: center;
        padding: 1.5rem 1rem;
        border-radius: 0.5rem;
        background-color: #cfd9df;
        gap: 1.5rem;

        @media ${theme.breakpoints.medium.media} {
            flex-direction: row;
            padding: 0.75rem 1rem;
            text-align: start;
        }

        @media ${theme.breakpoints.large.media} {
            padding: 1rem 2rem;
        }
    `}
`;

export const ViewAllLinksHeading = styled.p`
    ${({ theme }) => css`
        font-size: 1.5rem;
        font-family: ${theme.fonts.secondary};
        margin: 0;
        color: ${theme.colors.accents[5].hex};

        @media ${theme.breakpoints.large.media} {
            font-size: 1.875rem;
        }
    `}
`;

export const LinksWrapper = styled.div`
    ${({ theme }) => css`
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
        align-items: center;

        @media ${theme.breakpoints.medium.media} {
            flex-direction: row;
        }

        @media ${theme.breakpoints.large.media} {
            gap: 3rem;
        }
    `}
`;

export const StyledArrowLink = styled(Arrow)`
    text-wrap: nowrap;
`;

export const Filters = styled.div`
    ${({ theme }) => css`
        display: flex;
        flex-wrap: wrap;
        gap: 1rem;

        @media ${theme.breakpoints.xlarge.media} {
            flex-wrap: nowrap;
        }
    `}
`;

export const SelectWrapper = styled.div<{ $type: string }>`
    ${({ theme, $type }) => css`
        margin-top: 1rem;
        min-width: 12rem;
        flex-grow: 1;

        @media ${theme.breakpoints.medium.media} {
            margin-top: 0;
            flex-grow: 0;
        }

        @media ${theme.breakpoints.large.media} {
            min-width: 15rem;
        }

        @media ${theme.breakpoints.xlarge.media} {
            min-width: 12.5rem;
        }

        ${$type === 'courseOptions' &&
        css`
            @media ${theme.breakpoints.medium.media} {
                width: 20rem;
            }
        `}

        ${$type === 'courseCategories' &&
        css`
            min-width: 18rem;

            @media ${theme.breakpoints.medium.media} {
                max-width: 25rem;
            }

            @media ${theme.breakpoints.large.media} {
                min-width: 19rem;
            }

            @media ${theme.breakpoints.xlarge.media} {
                min-width: 16.5rem;
                max-width: none;
            }
        `}
    `}
`;

export const StyledIcon = styled(Cross)`
    width: 0.5rem;
    margin: 0 0 0.05rem 0.5rem;
`;

export const FilterPillButton = styled.button`
    ${({ theme }) => css`
        border-radius: 1.5rem;
        border: none;
        background: ${theme.colors.primaryContrast.hex};
        padding: 0.5rem 0.75rem;
        font-size: 1rem;
        cursor: pointer;
    `}
`;

export const InfoWrapper = styled.div<{ $filterInfoModal: boolean }>`
    ${({ theme, $filterInfoModal }) => css`
        margin: 1.5rem 0;

        @media ${theme.breakpoints.large.media} {
            display: flex;
            justify-content: space-between;
            margin: 3rem 0 1.5rem;
        }

        ${$filterInfoModal &&
        css`
            @media ${theme.breakpoints.medium.media} {
                margin-top: 0;
            }
        `}
    `}
`;

export const PillWrapper = styled.div`
    ${({ theme }) => css`
        display: flex;
        flex-wrap: wrap;
        gap: 0.5rem;

        @media ${theme.breakpoints.medium.media} {
            min-height: 2.5rem;
        }

        @media ${theme.breakpoints.large.media} {
            gap: 1rem;
        }
    `}
`;

export const ResultsText = styled.p`
    ${({ theme }) => css`
        font-size: 1rem;
        font-weight: 300;

        @media ${theme.breakpoints.medium.media} {
            text-align: right;
        }

        @media ${theme.breakpoints.large.media} {
            text-align: unset;
            font-size: 1.125rem;
            margin: 0 0 0 3rem;
            padding-top: 0.25rem;
            white-space: nowrap;
        }
    `}
`;

export const ResultsNumber = styled.span`
    ${({ theme }) => css`
        color: ${theme.colors.primary.hex};
        font-weight: 600;
    `}
`;

export const FilterInfoButton = styled.button`
    ${({ theme }) => css`
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 0.5rem;
        margin: 1rem 0;
        max-width: fit-content;
        border: none;
        background: none;
        color: ${theme.colors.accents[5].hex};
        text-decoration: underline;
        font-size: 1rem;

        :hover {
            cursor: pointer;
            text-decoration-thickness: 0.125rem;
        }
    `}
`;

export const FilterInfoIcon = styled.svg`
    ${({ theme }) => css`
        width: 1.25rem;
        min-width: 1.25rem;
        height: 1.25rem;
        border-radius: 50%;
        padding: 0.25rem;
        stroke-width: 0.05rem;
        color: ${theme.colors.secondary.hex};
        background-color: ${theme.colors.accents[7].hex};
    `}
`;

export const NoResults = styled.div`
    text-align: center;
    font-weight: 600;
    padding: 2rem 0 10rem;
    font-size: 1.25rem;

    @media ${({ theme }) => theme.breakpoints.large.media} {
        font-size: 1.5rem;
        padding: 2rem 0 15rem;
    }
`;
